/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Wrapped_Muscles_HeadlineInputs */

const en_us2_wrapped_muscles_headline = /** @type {(inputs: Wrapped_Muscles_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`muscle trained`);
	return /** @type {LocalizedString} */ (`muscles trained`)
	
};

const pt_br2_wrapped_muscles_headline = /** @type {(inputs: Wrapped_Muscles_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`músculo trabalhado`);
	return /** @type {LocalizedString} */ (`músculos trabalhados`)
	
};

const es_419_wrapped_muscles_headline = /** @type {(inputs: Wrapped_Muscles_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`músculo trabajado`);
	return /** @type {LocalizedString} */ (`músculos trabajados`)
	
};

const pt_pt2_wrapped_muscles_headline = /** @type {(inputs: Wrapped_Muscles_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`músculo trabalhado`);
	return /** @type {LocalizedString} */ (`músculos trabalhados`)
	
};

const fr_fr2_wrapped_muscles_headline = /** @type {(inputs: Wrapped_Muscles_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`muscle travaillé`);
	return /** @type {LocalizedString} */ (`muscles travaillés`)
	
};

const de_de2_wrapped_muscles_headline = /** @type {(inputs: Wrapped_Muscles_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Muskel trainiert`);
	return /** @type {LocalizedString} */ (`Muskeln trainiert`)
	
};

const it_it2_wrapped_muscles_headline = /** @type {(inputs: Wrapped_Muscles_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`muscolo allenato`);
	return /** @type {LocalizedString} */ (`muscoli allenati`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "muscle trained" |
* | * | "muscles trained" |
*
* @param {Wrapped_Muscles_HeadlineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_muscles_headline = /** @type {((inputs: Wrapped_Muscles_HeadlineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Muscles_HeadlineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_muscles_headline(inputs)
	if (locale === "es-419") return es_419_wrapped_muscles_headline(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_muscles_headline(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_muscles_headline(inputs)
	if (locale === "de-DE") return de_de2_wrapped_muscles_headline(inputs)
	if (locale === "it-IT") return it_it2_wrapped_muscles_headline(inputs)
	return en_us2_wrapped_muscles_headline(inputs)
});
export { wrapped_muscles_headline as "wrapped.muscles_headline" }